import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import {addNotification} from "./notifications";
import {CREATE_MATERIAL_SUCCESS, UPDATE_MATERIAL_SUCCESS} from "./materials";

export const REGISTER_MOVEMENT_REQUEST = 'REGISTER_MOVEMENT_REQUEST';
export const REGISTER_MOVEMENT_SUCCESS = 'REGISTER_MOVEMENT_SUCCESS';
export const REGISTER_MOVEMENT_ERROR = 'REGISTER_MOVEMENT_ERROR';
export const CLEAN_MOVEMENT = 'CLEAN_MOVEMENT';

// Register movement
export function registerMovement(movement) {
    return async (dispatch) => {
        try {
            dispatch(registerMovementRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/movements', movement, { headers: { 'Authorization': 'Bearer ' + token } });
            dispatch(utilsLib.response(res, registerMovementSuccess, registerMovementError));
        } catch (err) {
            dispatch(utilsLib.response(err, registerMovementError));
        }
    };
}

function registerMovementRequest() {
    return {
        type: REGISTER_MOVEMENT_REQUEST,
        isFetching: true
    };
}

function registerMovementSuccess (payload) {
    switch (payload[0].movement_type) {
        case 'Project':
            return dispatch => {
                // Create notification for create material success
                dispatch(addNotification({
                    message: payload.length > 1 ? 'Materiales añadidos correctamente' : 'Material añadido correctamente',
                    color: 'green',
                    icon: 'tick'
                }));
                for (const p of payload) {
                    dispatch({
                        type: CREATE_MATERIAL_SUCCESS,
                        isFetching: false,
                        error: false,
                        payload: p.material
                    });
                    dispatch({
                        type: REGISTER_MOVEMENT_SUCCESS,
                        isFetching: false,
                        error: false,
                        payload: p
                    });
                }
            };
        default:
            return {
                type: REGISTER_MOVEMENT_SUCCESS,
                isFetching: false,
                error: false,
                payload
            };
    }
}

function registerMovementError(errorMessage) {
    return dispatch => {
        // Create notification for create material success
        dispatch(addNotification({
            message: 'Error al añadir material',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: REGISTER_MOVEMENT_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    };
}

// Clean movement reducer
export function cleanMovement() {
    return {
        type: 'CLEAN_MOVEMENT',
        isFetching: false,
        error: false,
        payload: {}
    }
}

export const UPDATE_MOVEMENT_REQUEST = 'UPDATE_MOVEMENT_REQUEST';
export const UPDATE_MOVEMENT_SUCCESS = 'UPDATE_MOVEMENT_SUCCESS';
export const UPDATE_MOVEMENT_ERROR = 'UPDATE_MOVEMENT_ERROR';

// Update movement
export function updateMovement(movement) {
    return async (dispatch) => {
        try {
            dispatch(updateMovementRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/movements/${movement.movement_id}`, movement, { headers: { 'Authorization': 'Bearer ' + token } });
            dispatch(utilsLib.response(res, updateMovementSuccess, updateMovementError));
        } catch (err) {
            dispatch(utilsLib.response(err, updateMovementError));
        }
    };
}

function updateMovementRequest() {
    return {
        type: UPDATE_MOVEMENT_REQUEST,
        isFetching: true
    };
}

function updateMovementSuccess (payload) {
    switch (payload.movement_type) {
        case 'Project':
            return dispatch => {
                // Create notification for update material success
                dispatch(addNotification({
                    message: 'Material actualizado correctamente',
                    color: 'green',
                    icon: 'tick'
                }));
                dispatch({
                    type: UPDATE_MATERIAL_SUCCESS,
                    isFetching: false,
                    error: false,
                    payload: payload.material
                });
                dispatch({
                    type: UPDATE_MOVEMENT_SUCCESS,
                    isFetching: false,
                    error: false,
                    payload: payload
                });
            };
        default:
            return {
                type: UPDATE_MOVEMENT_SUCCESS,
                isFetching: false,
                error: false,
                payload
            };
    }
}

function updateMovementError(errorMessage) {
    return dispatch => {
        // Create notification for update material success
        dispatch(addNotification({
            message: 'Error al actualizar material',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPDATE_MOVEMENT_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    };
}


// WEBPACK FOOTER //
// ./src/actions/movement.js